<template>
  <div id="app">
    <headers v-if="showHeader"></headers>
    <router-view />
    <footers v-if="showHeader"></footers>
  </div>
</template>

<script>
import headers from '@/components/header.vue';
import footers from '@/components/footer.vue';
  export default {
    components:{headers,footers},
    name: "App",
    computed: {
      showHeader() {
        // 默认显示，如果 meta 显式为 false 就不显示
        return this.$route.meta.showHeader !== false;
      },
      showFooter() {
        return this.$route.meta.showFooter !== false;
      }
    }
  };
</script>

<style>
  body {
    margin: 0;
  }
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue